import { createSelector } from 'reselect';
import { RouteName } from '@mews-commander/enums';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { canCurrentProfileViewSensitiveReports } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { isCurrentEnterpriseAnalyticsIntegrationEnabled } from '@mews-commander/legacy-entities/src/selectors';
import { mapAnalyticsTypeTextKey } from '../../../powerBi/utils';
import AnalyticsType from '../../../powerBi/enums/analyticsType';
import { getSimpleSearchResult } from './getSimpleSearchResult';

export default createSelector(
    getCurrentEnterpriseId,
    isCurrentEnterpriseAnalyticsIntegrationEnabled,
    canCurrentProfileViewSensitiveReports,
    (enterpriseId: string, isEnabled: boolean, canViewSensitiveReports: boolean) => {
        const isMewsAnalyticsAvailable = canViewSensitiveReports && isEnabled;

        const analyticsResults = isMewsAnalyticsAvailable
            ? [
                  getSimpleSearchResult({
                      routeName: RouteName.AnalyticsIndex,
                      titleKey: mapAnalyticsTypeTextKey[AnalyticsType.Manager],
                      params: { query: { type: AnalyticsType.Manager } },
                  }),
                  getSimpleSearchResult({
                      routeName: RouteName.AnalyticsIndex,
                      titleKey: mapAnalyticsTypeTextKey[AnalyticsType.Financial],
                      params: { query: { type: AnalyticsType.Financial } },
                  }),
                  getSimpleSearchResult({
                      routeName: RouteName.AnalyticsIndex,
                      titleKey: mapAnalyticsTypeTextKey[AnalyticsType.Outlet],
                      params: { query: { type: AnalyticsType.Outlet } },
                  }),
                  getSimpleSearchResult({
                      routeName: RouteName.AnalyticsIndex,
                      titleKey: mapAnalyticsTypeTextKey[AnalyticsType.Pickup],
                      params: { query: { type: AnalyticsType.Pickup } },
                  }),
              ]
            : [];

        return analyticsResults;
    }
);
